/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autosave_PendingInputs */

const cs_autosave_pending = /** @type {(inputs: Autosave_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuložené změny…`)
};

const en_autosave_pending = /** @type {(inputs: Autosave_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes…`)
};

/**
* | output |
* | --- |
* | "Unsaved changes…" |
*
* @param {Autosave_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const autosave_pending = /** @type {((inputs?: Autosave_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autosave_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autosave_pending(inputs)
	return cs_autosave_pending(inputs)
});